/** Suppress Listy default `controlItemBgHover`; opt in on item or row wrapper. */
export const LISTY_ITEM_NO_HOVER = '[&:hover]:bg-transparent!';
